/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import AppLink from '../../../shared/components/app-link/AppLink';
import { formatCurrency } from '../../../shared/helper-utils/appUtils';

function HotelListCard({
  hotelData,
  onRoomChoose,
  handleMouseOver,
  handleMouseOut,
}) {
  return (
    <Card
      className="p-2 cursor-pointer hotel-list-card"
      onMouseOver={() => handleMouseOver(hotelData)}
      onMouseOut={() => handleMouseOut(null)}
    >
      <div className="d-flex flex-column ">
        <AppLink
          variant="primary"
          linkText={hotelData.hn}
          className="fs-16 fw-600"
          onClick={() => onRoomChoose(hotelData)}
        />
        <span className="fs-12">{hotelData.addr}</span>
        <span className="fs-16 fw-500">
          {hotelData.mp ? formatCurrency(hotelData.mp) : 'N/A'}
        </span>
      </div>
    </Card>
  );
}

HotelListCard.defaultProps = {
  handleMouseOver: () => {},
  handleMouseOut: () => {},
};

HotelListCard.propTypes = {
  hotelData: PropTypes.object.isRequired,
  onRoomChoose: PropTypes.func.isRequired,
  handleMouseOver: PropTypes.func,
  handleMouseOut: PropTypes.func,
};

export default HotelListCard;
